import { useEffect } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { isEmpty, isEqual } from "lodash"
import { COOKIE_TOKEN, STORAGE_USER_PATHNAME } from "config/const/global"
import { delCookie, getCookie, setCookie } from "./cookies"
import { tokenHandler } from "config/slice/global"
import { setTabById } from "config/slice/sidebar"

/**
 * check login token, go to homepage if token exists, otherwise go to login page
 */
const useCheckToken = () => {

    const { token } = useSelector(state => state.global)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { pathname, search } = useLocation()
    let lToken = getCookie(COOKIE_TOKEN)

    const checkFn = () => {
        if (!isEmpty(lToken) && isEqual(lToken, token)) {
            if (isEqual(pathname, '/login')) {
                dispatch(setTabById(3))
                return navigate('/individualAcc', { replace: true })
            }
            navigate(`${pathname}${search}`, { replace: true })
        }
        else {
            delCookie(COOKIE_TOKEN)
            dispatch(tokenHandler({
                switch: false
            }))
            navigate('/login', { replace: true })
        }
    }

    useEffect(() => {
        switch (pathname) {
            case '/login':
            case '/reg':
            case '/forgetPwd':
            case '/resetPwd':
                break;

            default:
                setCookie(STORAGE_USER_PATHNAME, `${pathname}${search}`)
                break;
        }
        checkFn()
    }, [])
}

export default useCheckToken